export default __webpack_public_path__ + "static/media/trans.de7f6c59.png";